import { Directive, ElementRef, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[scrollAnchor]',
  standalone: false
})
export class ScrollAnchorDirective implements OnInit, OnDestroy {
  private observer!: MutationObserver;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.observer = new MutationObserver(() => {
      this.el.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
    });

    this.observer.observe(this.el.nativeElement.parentElement, {
      childList: true,
      subtree: true,
    });
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}